import type { SiteHeader } from '@ps/web-martech-cms-types';
import type {
  SecondaryNavigationBlock,
  SupportNavigationBlock
} from '@ps/web-martech-cms-types/SiteHeader';
import classNames from 'clsx';
import React from 'react';

import useCustomHeader from '../../../../hooks/useCustomHeader';
import CMSResolverLink from '../../../CMSResolverLink/CMSResolverLink';
import LocalesDropDown from '../LocalesDropDown/LocalesDropDown';

import styles from './CMSHeaderMenu.scss';

interface Props {
  items: SupportNavigationBlock[] | SecondaryNavigationBlock[];
  className?: string;
  layout?: SiteHeader['layout'];
  secondaryMenu?: boolean;
  onClick?: () => void;
}

const CMSHeaderMenu: React.FC<Props> = ({
  items,
  className,
  layout,
  onClick,
  secondaryMenu = false
}) => {
  const { showLocalesDropdown } = useCustomHeader();

  return items.length ? (
    <ul className={classNames(styles.cmsMenu, className)}>
      {items.map((item, index) =>
        item.icon?.toLowerCase() === 'languages' ? (
          <LocalesDropDown key={`${item.icon}${index}`} className={styles.menuItem} />
        ) : !showLocalesDropdown ? (
          <li
            key={`${item.title}${index}`}
            className={classNames(styles.menuItem, {
              [styles.noActiveStyle]: secondaryMenu && layout === 'Play Money'
            })}
          >
            <CMSResolverLink {...item} onClick={onClick} />
          </li>
        ) : null
      )}
    </ul>
  ) : null;
};
export default React.memo(CMSHeaderMenu);
